module.exports = __webpack_public_path__ + "img/contract-grey.f4ae43c5.svg";